<script lang="ts">
  import { onMount } from 'svelte';

  import { fade } from 'svelte/transition';
  import { getStorage, LsKey, setStorage } from '../../lib/storage';
  import InlineSvg from '../elements/InlineSvg.svelte';

  const list = '4D11uiw2GzfqkNw763S596iw';
  const api_key = 'aT3dOMi2pRtyya5VJUkK';
  let emailInput: HTMLInputElement;
  let errorMessage: HTMLDivElement;

  let result = '';
  let email = '';
  let isModalVisible = getStorage(LsKey.NEWSLETTER_MODAL_VISIBLE, true);
  let features = [
    {
      icon: '/img/icon/articles.svg',
      text: 'Best <strong>Articles</strong> from Design Blogs',
    },
    {
      icon: '/img/icon/branding.svg',
      text: 'Curated <strong>Branding</strong> Inspiration',
    },
    {
      icon: '/img/icon/palettes.svg',
      text: '<strong>Color Palettes</strong> of the Week',
    },
    {
      icon: '/img/icon/reddit.svg',
      text: 'Trending Content from <strong>Reddit</strong>',
    },
    {
      icon: '/img/icon/products.svg',
      text: 'Handpicked Weekly <strong>Products</strong>',
    },
    {
      icon: '/img/icon/fonts.svg',
      text: 'Popular <strong>Fonts</strong> of the Week',
    },
  ];

  if (!isModalVisible) {
    setTimeout(() => {
      isModalVisible = true;
      setStorage(LsKey.NEWSLETTER_MODAL_VISIBLE, true);
    }, 2000);
  }

  // function closeModal() {
  //   isModalVisible = false;
  // }

  async function onSubmit() {
    if (emailInput.checkValidity()) {
      let data = new FormData();

      data.append('list', list);
      data.append('api_key', api_key);
      data.append('email', email);
      data.append('boolean', 'true');

      try {
        const response = await fetch('https://empweekly.com/sendy/subscribe', {
          method: 'POST',
          body: data,
        });
        result = await response.text();

        if (result === '1') {
          email = '';
        } else {
          result = result;
          errorMessage.style.visibility = 'visible';
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      errorMessage.style.visibility = 'visible';
      console.log('else', emailInput.checkValidity());
    }
  }

  function closeModal() {
    isModalVisible = false;

    if (history.length > 2) {
      window.history.back();
    } else {
      window.history.replaceState(null, null, '/');
    }
  }
</script>

<div class="modal-curtain" in:fade class:visible={isModalVisible}>
  <div class="modal-container">
    <button class="close-button" on:click={closeModal}>
      <InlineSvg src="/img/icon/close.svg" width="14px" height="14px" />
    </button>
    <div class="content">
      <div class="title">
        <span>Our Free Newsletter is Launching Soon!</span>
        <div class="subtitle">
          Get the earliest access to hand-picked content weekly for free.
        </div>
      </div>
      <div class="features">
        <ul>
          {#each features as feature}
            <li><InlineSvg src={feature.icon} /><span>{@html feature.text}</span></li>
          {/each}
        </ul>
      </div>
    </div>
    <div class="subscription">
      <div class="subscribe">
        {#if result !== '1'}
          <h3 class="title" in:fade>Subscribe</h3>
          <form class="action" on:submit|preventDefault={onSubmit}>
            <input
              type="email"
              bind:value={email}
              bind:this={emailInput}
              placeholder="Enter your email to subscribe"
              required
            />
            <span class="input-icon" type="submit" on:click={onSubmit} />
            <div class="error-message" bind:this={errorMessage}>
              <InlineSvg src="/img/icon/error.svg" width="12px" height="12px" />
              <small>{result ? result : 'Please enter a valid email address'}</small>
            </div>
          </form>
        {:else}
          <h3 class="title" in:fade>🎉 Thank You!</h3>
          <p in:fade>You will receive our first newsletter issue soon.</p>
        {/if}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../styles/mixins';

  .modal-curtain {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: calc(100vh - 60px);
    background-color: rgba(255, 255, 255, 0.8);
    opacity: 0;
    pointer-events: none;
    transition: all 0.2s ease-in;
    z-index: 4;

    &::after {
      contain: url('/img/mesh-gradient.png');
      position: absolute;
      width: 0;
      height: 0;
      overflow: hidden;
      z-index: -1;
    }

    &.visible {
      opacity: 1;
      pointer-events: all;
    }

    .modal-container {
      position: relative;
      overflow-y: overlay;
      background-image: url('/img/mesh-gradient.png');
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 100%;
      padding: 40px 24px;
      display: flex;
      flex-direction: column;

      .close-button {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 16px;
        background-color: rgba(255, 255, 255, 0.1);
        --svg-stroke: white;
        cursor: pointer;
      }

      .content {
        display: flex;
        flex-direction: column;
        justify-items: center;
        border-bottom: 1px solid white;

        .title {
          @include font(Semibold);
          font-size: 28px;
          line-height: 110%;
          color: var(--color-blue-gray--100);
          border-bottom: 1px solid white;
          padding-bottom: 32px;

          .subtitle {
            @include font();
            margin-top: 16px;
            font-size: 16px;
            line-height: 120%;
          }
        }

        .features ul {
          display: grid;
          grid-template-columns: 1fr;
          color: var(--color-blue-gray--100);
          padding: 12px 0;

          li {
            display: inline-flex;
            margin: 12px 0;
            @include font();
            font-size: 18px;
            line-height: 120%;

            span {
              margin-left: 16px;
            }

            :global(.svg-wrapper) {
              display: inline-block;
              margin: 0;
              padding: 0;
            }
          }
        }
      }

      .subscription {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .subscribe {
          .title {
            @include font(Semibold);
            font-size: 28px;
            line-height: 110%;
            color: white;
            margin-top: 32px;
            margin-bottom: 20px;
            user-select: none;

            & + p {
              @include font();
              font-size: 24px;
              line-height: 110%;
              color: white;
              height: 88px;
              margin-bottom: 48px;
            }
          }

          .action {
            * {
              outline: none;
            }
            height: 88px;
            position: relative;

            input {
              width: 100%;
              // height: 58px;
              font-size: 16px;
              line-height: 140%;
              background-color: transparent;
              padding: 17px 16px;
              border: 2px solid rgba(255, 255, 255, 0.5);
              border-radius: 8px;
              color: white;
              transition: all 0.1s ease-in, filter 0.1s linear;

              &::placeholder {
                color: white;
                opacity: 0.6;
                user-select: none;
              }

              &:hover {
                background-color: rgba(255, 255, 255, 0.1);

                & + .input-icon::after {
                  opacity: 1;
                }
              }

              &:focus {
                background-color: rgba(255, 255, 255, 0.1);
                border: 2px solid white;

                & + .input-icon::after {
                  content: url('/img/icon/arrow-right.svg');
                  background-color: white;
                  opacity: 1;
                }
              }

              &:not(:focus):not(:placeholder-shown):invalid {
                background-color: #ff151566;
                opacity: 1;
              }
            }

            input + .input-icon::after {
              content: url('/img/icon/chevron.svg');
              display: block;
              width: 56px;
              height: 56px;
              padding: 16px;
              position: absolute;
              right: 0;
              top: 2px;
              cursor: pointer;
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;
              opacity: 0.6;
              transition: all 0.1s ease-in;
            }

            input:not(:focus):not(:placeholder-shown):invalid + .input-icon::after {
              cursor: default;
              content: url('/img/icon/times.svg');
              pointer-events: none;
              opacity: 1;
            }

            .error-message {
              visibility: hidden;
              display: flex;
              align-items: center;
              margin-top: 10px;
              gap: 4px;

              span {
                @include font(Semibold);
                font-size: 12px;
                line-height: 140%;
                color: var(--color-blue-gray--900);
              }
            }
          }
        }
      }
    }

    :global(strong) {
      text-decoration: underline;
    }
  }

  :global(.dark-mode) {
    .modal-curtain {
      background-color: rgba(0, 0, 0, 0.8);
    }
  }
</style>
